import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PROMPT-040: Master Admin Route Guard
 * 
 * This component enforces STRICT access control:
 * - ONLY Master Admin role can access protected routes
 * - All other roles are redirected to Access Denied page
 * - Unauthenticated users are redirected to Login
 */
const MasterAdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');

  // Check if user is authenticated
  if (!token || !userStr) {
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);
    
    // STRICT: Only MASTER_ADMIN role is allowed
    // Check for both lowercase and uppercase variants
    const isMasterAdmin = 
      user.role === 'master_admin' || 
      user.role === 'MASTER_ADMIN' ||
      user.role === 'Master Admin';

    if (!isMasterAdmin) {
      return <Navigate to="/access-denied" replace />;
    }

    // User is Master Admin - allow access
    return children;
  } catch (error) {
    // Invalid user data - redirect to login
    console.error('Error parsing user data:', error);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/login" replace />;
  }
};

export default MasterAdminRoute;
